import React from 'react';
import { IconedButton } from 'components/IconedButton';
import CW from '../images/coverwhale_logo_white.png';
import styles from '../styles.module.scss';

const TicketDetails = ({
  ticketData,
  handleUpdateTicketIssue,
  ticketIssue,
  handleIssueChange,
  selectedIssues,
  handleNextClick,
  setModal
}) => {
  const isIssueSelectionScreen = ticketData.ticketIssues.length === 0 || !ticketData.messages;

  return (
    <div className="w-full md:w-1/2">
      <div
        className="mb-6 rounded-[12px] w-full mx-auto bg-white pb-6 max-w-screen-xl"
        id="14"
      >
        <header className="bg-black flex items-center justify-between px-4 pb-2 pt-2 rounded-t-[12px]">
          <img src={CW} alt="Cover Whale" className="w-[360px]" />
        </header>

        {isIssueSelectionScreen ? (
          <>
            <div className="flex-col border rounded p-4 mt-4 pt-0 border-slate-300 mx-6">
              <div className="flex justify-between py-2 border-b border-slate-300">
                <div>Ticket Number</div>
                <div>{ticketData.ticketNumber}</div>
              </div>
              {ticketData.companyName && (
                <>
                  <div className="flex justify-between py-2 border-b border-slate-300">
                    <div>Company Name</div>
                    <div>{ticketData.companyName}</div>
                  </div>
                  <div className="flex justify-between pt-2">
                    <div>Company Email</div>
                    <div>{ticketData.assignedUserEmail}</div>
                  </div>
                </>
              )}
            </div>

            <div className="p-4 pl-6 mt-4 pt-0">
              Select issues that need to be addressed:
            </div>

            <div className="flex-col border rounded p-4 pt-0 border-slate-300 mx-6">
              {ticketIssue.map((issue, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2 border-b border-slate-300"
                >
                  <div>{issue.value}</div>
                  <input
                    type="checkbox"
                    checked={selectedIssues.some(
                      (i) => i.value === issue.value
                    )}
                    onChange={() => handleIssueChange(issue.value)}
                  />
                </div>
              ))}
            </div>

            <div className="p-4 mt-4 pt-0">
              <div className="w-full flex items-center">
                <IconedButton
                  size="1500px"
                  color="#d32425"
                  textColor="white"
                  text="Next"
                  action={() => handleNextClick()}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex-col border rounded p-4 mt-4 pt-0 border-slate-300 mx-6">
              <div className="flex justify-between py-2 border-b border-slate-300">
                <div>Ticket Number</div>
                <div>{ticketData.ticketNumber}</div>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-300">
                <div>Agency Name</div>
                <div>{ticketData.agencyName}</div>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-300">
                <div>Agency Email</div>
                <div>{ticketData.assignedAgentEmail}</div>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-300">

                <div>Agency Phone</div>
                <div>{ticketData.agencyPhone || 'N/A'}</div>
              </div>
              <div className="flex justify-between py-2 border-b border-slate-300">
                <div>Submission Number</div>
                <div>{ticketData.submissionNumber}</div>
              </div>
              <div className="flex justify-between py-2">
                <div>Name of Insured</div>
                <div>{ticketData.companyName}</div>
              </div>
            </div>

            <div className="p-4 pl-6 mt-4 pt-0">
              Check an issue to mark it as solved:
            </div>

            <div className="flex-col border rounded p-4 pt-0 border-slate-300 mx-6">
              {ticketData.ticketIssues.map((issue, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2 border-b border-slate-300"
                >
                  <div className="inline-flex items-center">
                    {issue.value}
                  </div>
                  <div className="inline-flex items-center">
                    <label className={styles.label}>
                      <span className={styles.checkbox_container}>
                        <input
                          type="checkbox"
                          className={styles.checkbox}
                          checked={issue.solved}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            handleUpdateTicketIssue(
                              issue.value,
                              isChecked
                            );
                          }}
                          disabled={
                            ticketData.ticketStatus === 'Completed'
                          }
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={styles.icon}
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                    </label>
                  </div>
                </div>
              ))}
            </div>

            {ticketData.ticketStatus === 'Completed' ? null : (
              <div className="p-4 mt-4 pt-0">
                <div className="w-full flex items-center">
                  <IconedButton
                    size="1500px"
                    color="#d32425"
                    textColor="white"
                    text="Add"
                    action={() => {
                      setModal({
                        name: 'add_ticket_issue_modal',
                        data: {
                          ticketStatus: ticketData.ticketStatus,
                          ticketIssues: ticketData.ticketIssues,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TicketDetails;
